import BaseAPI from './base'
/**
 * API xử lý game
 */
class StudentGameAPI extends BaseAPI {}

export default new StudentGameAPI('v1/student-game', 'StudentGame')
